import JustValidate from 'just-validate'

document.addEventListener('DOMContentLoaded', function () {
	const signinForm = document.getElementById('signinForm')
	const signUpForm = document.getElementById('signupForm')
	const passwordForm = document.getElementById('passwordForm')
	const passwordNewForm = document.getElementById('passwordNewForm')

	if (signinForm) {
		const validator = new JustValidate('#signinForm')

		validator
			.addField('#email', [{ rule: 'required' }, { rule: 'email' }])
			.addField('#password', [{ rule: 'required' }])

		signinForm.addEventListener('submit', function (event) {
			event.preventDefault()

			validator.validate()

			if (validator.isValid) {
				let formData = new FormData(signinForm)
				for (let pair of formData.entries()) {
					console.log(pair[1])
				}
			}
		})
	}

	if (signUpForm) {
		const validator = new JustValidate('#signupForm')

		validator.addField('#email', [{ rule: 'required' }, { rule: 'email' }])

		signUpForm.addEventListener('submit', function (event) {
			event.preventDefault()

			validator.validate()

			if (validator.isValid) {
				let formData = new FormData(signUpForm)
				for (let pair of formData.entries()) {
					console.log(pair[1])
				}
			}
		})
	}

	if (passwordForm) {
		const validator = new JustValidate('#passwordForm')

		validator.addField('#email', [{ rule: 'required' }, { rule: 'email' }])

		passwordForm.addEventListener('submit', function (event) {
			event.preventDefault()

			validator.validate()

			if (validator.isValid) {
				let formData = new FormData(passwordForm)
				for (let pair of formData.entries()) {
					console.log(pair[1])
				}
			}
		})
	}

	if (passwordNewForm) {
		const validator = new JustValidate('#passwordNewForm')

			.addField('#password', [
				{
					rule: 'required'
				}
			])
			.addField('#passwordNew', [
				{
					rule: 'required'
				},
				{
					validator: (value, fields) => {
						if (fields['#password'] && fields['#password'].elem) {
							const repeatPasswordValue = fields['#password'].elem.value

							return value === repeatPasswordValue
						}

						return true
					},
					errorMessage: 'Passwords should be the same'
				}
			])

		passwordNewForm.addEventListener('submit', function (event) {
			event.preventDefault()

			validator.validate()

			if (validator.isValid) {
				let formData = new FormData(passwordNewForm)
				for (let pair of formData.entries()) {
					console.log(pair[1])
				}
			}
		})
	}
})
